function getOpt (pmData) {
 let xData = pmData.time;
 let y1Data = pmData.tdcVal;
 let y2Data = pmData.noxVal;
 let y3Data = pmData.so2Val;

 return {
  backgroundColor: "transparent",
  tooltip: {
   show: true,
   trigger: 'axis',
   backgroundColor: 'rgba(4, 21, 39, 1)',
   borderWidth: 0,
   textStyle: {
    color: '#fff'
   }
  },
  legend: {
   show: true,
   icon: 'rect',
   itemWidth: 14,
   itemHeight: 4,
   right: '2%',
   top: '8%',
   textStyle: {
    fontSize: 14,
    color: 'rgba(255,255,255,1)',
    padding: [2, 0, 0, 0]
   }
  },
  grid: {
   top: '20%',
   left: '1%',
   right: '1%',
   bottom: '10%',
   containLabel: true,
  },
  xAxis: [{
   type: 'category',
   axisLine: {
    show: true,
    lineStyle: {
     color: '#093E95',
     width: 0.1
    },
   },
   boundaryGap: true,
   axisLabel: {
    textStyle: {
     color: "#9FBAFD",
     fontSize: 12,
     margin: 15,
    },
   },
   axisTick: {
    show: false,
   },
   data: xData,
  }],
  yAxis: [{
   name: '单位：kg',
   nameTextStyle: {
    fontSize: 14,
    color: "#9FBAFD",
    padding: [0, 0, 0, 20]
   },
   type: 'value',
   min: 0,
   //minInterval: 50,
   splitLine: {
    show: false,
    lineStyle: {
     color: '#093E95',
     width: 0.3
    }
   },
   axisLine: {
    show: true,
    lineStyle: {
     color: '#093E95',
     width: 1
    }
   },
   axisLabel: {
    margin: 10,
    textStyle: {
     color: '#9FBAFD',
     fontSize: 12,
    },
   },
   axisTick: {
    show: false,
   },
  }],
  series: [{
   name: "tdc",
   type: 'bar',
   barMaxWidth: "30%",
   itemStyle: {
    barBorderRadius: [3, 3, 0, 0],
    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
     offset: 0,
     color: '#05fffa'
    },
    {
     offset: 1,
     color: '#2871ff00'
    }
    ], false)
   },
   data: y1Data
  }, {
   name: "nox",
   type: 'bar',
   barMaxWidth: "30%",
   itemStyle: {
    barBorderRadius: [3, 3, 0, 0],
    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
     offset: 0,
     color: '#0091ff'
    },
    {
     offset: 1,
     color: '#2871ff00'
    }
    ], false)
   },
   data: y2Data
  }, {
   name: "so2",
   type: 'bar',
   barMaxWidth: "30%",
   itemStyle: {
    barBorderRadius: [3, 3, 0, 0],
    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
     offset: 0,
     color: '#f7b500'
    },
    {
     offset: 1,
     color: '#2871ff00'
    }
    ], false)
   },
   data: y3Data
  }]
 };
}

export default getOpt